import React, { ReactNode } from "react";

import { Box, Container, Drawer, IconButton, Typography } from "@mui/material";

import CloseIcon from "~public/icons/More/More Close.svg";

export interface IFullscreenDrawer {
  isOpen: boolean;
  handleClose: () => void;
  title: string;
  children: ReactNode;
  leftButton?: ReactNode;
  rightButton?: ReactNode;
}

export const FullscreenDrawer = ({
  isOpen,
  handleClose,
  title,
  leftButton,
  rightButton,
  children
}: IFullscreenDrawer): JSX.Element => {
  return (
    <Drawer
      sx={{ zIndex: 1001 }}
      PaperProps={{
        elevation: 0,
        sx: { maxHeight: "100vh", zIndex: -50 }
      }}
      hideBackdrop
      anchor={"right"}
      open={isOpen}
      onClose={handleClose}>
      <Container
        disableGutters
        sx={{
          position: "relative",
          minWidth: "100vw",
          height: "100%",
          display: "flex",
          flexDirection: "column"
        }}>
        <Box
          sx={{
            px: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 3,
            mt: 2.5
          }}>
          {leftButton ? (
            leftButton
          ) : (
            <IconButton onClick={handleClose} id={"fullscreen_drawer__close"}>
              <CloseIcon style={{ fontSize: 22 }} />
            </IconButton>
          )}
          <Typography fontSize={24} fontWeight={400} whiteSpace={"nowrap"}>
            {title}
          </Typography>
          {rightButton ? rightButton : <div style={{ width: "38px" }} />}
        </Box>
        {children}
      </Container>
    </Drawer>
  );
};
